








































































































































































































  import { Component, Prop, Vue } from 'vue-property-decorator';

  import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
  import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
  import { UnitSystem } from '@/interfaces/units';
  import { CM_TO_INCHES, KG_TO_LB, MPA_TO_PSI, PSI_TO_MPA } from '@/lib/unitConversion/unitConversionFactors';
  import QuickHelp from '@/views/components/input/QuickHelp.vue';
  import { findEp } from '@/modules/design/lib/calculations/calculationUtils';
  import CoreQuestions from '@/modules/design/views/acOverlay/components/CoreQuestions.vue';
  import { IAcOverlayDesignImperial, IAcOverlayDesignMetric } from '../../../interfaces/acOverlay';


@Component({
  components: {
    CoreQuestions,
    QuickHelp,
    PxDropdown,
    PxNumberInput,
  },
})
  export default class NonDestructiveTesting extends Vue {
  @Prop() scenario!: IAcOverlayDesignImperial | IAcOverlayDesignMetric;

  @Prop({ default: null }) validationObject!: any;

  unitSystemImperial = UnitSystem.Imperial;

  get unitSystemIsImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  sync() {
    this.$emit('sync');
  }

  get designSubgradeModulus() {
    return this.scenario.unitSystem === this.unitSystemImperial
        // @ts-ignore
        ? this.scenario.designSubgradeModulus_psi : this.scenario.designSubgradeModulus_mpa;
  }

  yesNoOptions = [
    { value: true, text: 'Yes' },
    { value: false, text: 'No' },
  ];

  crackTypeOptions = [
    { value: 'Top-Down Only', text: 'Top-Down Only' },
    { value: 'Entire Depth', text: 'Entire Depth' },
    { value: 'Both', text: 'Both' },
  ];

  /*
  Subgrade modulus calculator
   */

  appliedLoad = 0;

  radialDistance = 0;

  deflectionRadialDistance = 0;

  cValue = 0.33;

  get designMr(): number {
    // Calculation from original router.js #calculate_design_subgrade_modulus onClick handler
    let C: number;
    let r: number;
    let P: number;
    let dr: number;

    let mr: number;

    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      C = this.cValue;
      r = this.radialDistance;
      P = this.appliedLoad;
      dr = this.deflectionRadialDistance;

      mr = C * (0.24 * P) / (dr * r);
    } else {
      C = this.cValue;
      r = this.radialDistance * CM_TO_INCHES;
      P = this.appliedLoad * KG_TO_LB;
      dr = this.deflectionRadialDistance * CM_TO_INCHES;

      mr = C * (0.24 * P) / (dr * r) * PSI_TO_MPA;
    }

    return mr;
  }

  setSubgradeModulus() {
    if (this.scenario.unitSystem === UnitSystem.Imperial) {
      this.scenario.designSubgradeModulus_psi = this.designMr;
    } else {
      this.scenario.designSubgradeModulus_mpa = this.designMr;
    }
    this.sync();
  }

  /*
  SnEff calculator
   */

  deflectionSn = 0;

  contactPressure = 0;

  loadPlateRadius = 0;

  get findEpResults() {
    console.log('running findEp');

    let d: number;
    let p: number;
    let a: number;
    let m: number;
    let D: number;
    let Mr: number;

    const minEp = 25000;
    const maxEp = 3000000;
    const loops = 0;

    let results;

    if (this.scenario.unitSystem === UnitSystem.Imperial && this.scenario.designSubgradeModulus_psi !== null) {
      // All the inputs are imperial units
      d = this.deflectionSn;
      p = this.contactPressure;
      a = this.loadPlateRadius;
      m = this.scenario.designSubgradeModulus_psi;
      D = this.pavementThickness;

      results = findEp(d, p, a, D, m, minEp, maxEp, loops);
    } else if (this.scenario.unitSystem === UnitSystem.Metric && this.scenario.designSubgradeModulus_mpa !== null) {
      // ALl inputs are metric units, need to convert
      d = this.deflectionSn * CM_TO_INCHES;
      p = this.contactPressure * MPA_TO_PSI;
      a = this.loadPlateRadius * CM_TO_INCHES;
      m = this.scenario.designSubgradeModulus_mpa * MPA_TO_PSI;
      D = this.pavementThickness; // Conversion handled in the getter


      results = findEp(d, p, a, D, m, minEp, maxEp, loops);
    } else {
      results = { ep: null, SNeff: null };
    }

    return results;
  }

  get calculatedEffModulus() {
    return this.findEpResults.ep;
  }

  get calculatedSnEff() {
    return this.findEpResults.SNeff;
  }

  setSnEff() {
    this.scenario.combinedLayerStiffness = this.calculatedSnEff;
    this.sync();
  }

  get pavementThickness() {
    let total = 0;
    if (this.isImperial) {
      this.scenario.existingLayers.forEach((L: any) => {
        total += L.thickness_in;
      });
    } else {
      this.scenario.existingLayers.forEach((L: any) => {
        total += L.thickness_cm;
      });
    }
    return total;
  }

  /*
  Units
   */
  get isImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  get loadUnit() {
    return this.scenario.unitSystem === UnitSystem.Imperial ? 'lb' : 'kg';
  }

  get lengthUnit() {
    return this.scenario.unitSystem === UnitSystem.Imperial ? 'in' : 'cm';
  }

  get depthUnit() {
    return this.scenario.unitSystem === UnitSystem.Imperial ? 'in' : 'cm';
  }

  get pressureUnit() {
    return this.scenario.unitSystem === UnitSystem.Imperial ? 'psi' : 'MPa';
  }
  }
